import { QueryClient } from '@tanstack/react-query';
import {
    persistQueryClient,
  } from '@tanstack/react-query-persist-client'
import {
    createAsyncStoragePersister,
  } from '@tanstack/query-async-storage-persister'

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: (failureCount) => failureCount < 3,
            //refetchOnWindowFocus: false, // Disable refetch on window focus,
            //gcTime: 1000 * 60 * 5, // 5 minutes
        },
    },
});

const localStoragePersister = createAsyncStoragePersister({
    storage: window.localStorage,
})
  
// Enable persistence
persistQueryClient({
    queryClient,
    persister: localStoragePersister,
    dehydrateOptions: {
        // Save only queries that match certain keys
        shouldDehydrateQuery: (query) => query.meta?.persist === true,
    }
})
